var _rect, _g, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111470_19003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 85,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3335,
    y: 1,
    width: 84,
    height: 84,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111470_19003)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.3335,
    y: 1,
    width: 84,
    height: 84,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.3335,
    y: 1,
    width: 86.9647,
    height: 6,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.31006,
    cy: 4,
    r: 1,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.31006,
    cy: 4,
    r: 1,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.3101,
    cy: 4,
    r: 1,
    fill: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2046 10C26.2046 9.44772 26.6523 9 27.2046 9H82.5222C83.0745 9 83.5222 9.44772 83.5222 10V15C83.5222 15.5523 83.0745 16 82.5222 16H27.2046C26.6523 16 26.2046 15.5523 26.2046 15V10Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 7H24.0629V85H3.33349C2.22893 85 1.3335 84.1046 1.3335 83V7Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8335 16C8.76649 16 10.3335 14.433 10.3335 12.5C10.3335 10.567 8.76649 9 6.8335 9C4.9005 9 3.3335 10.567 3.3335 12.5C3.3335 14.433 4.9005 16 6.8335 16Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3335 11.5C12.3335 10.9477 12.7812 10.5 13.3335 10.5H21.3335C21.8858 10.5 22.3335 10.9477 22.3335 11.5V13.5C22.3335 14.0523 21.8858 14.5 21.3335 14.5H13.3335C12.7812 14.5 12.3335 14.0523 12.3335 13.5V11.5Z",
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7294,
    height: 61,
    transform: "matrix(-1 0 0 1 22.063 22)",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 23C22.063 22.4477 21.6153 22 21.063 22H4.33358C3.78129 22 3.33358 22.4477 3.33358 23V23C3.33358 23.5523 3.78129 24 4.33358 24H21.063C21.6153 24 22.063 23.5523 22.063 23V23Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 28C22.063 27.4477 21.6153 27 21.063 27H4.33358C3.78129 27 3.33358 27.4477 3.33358 28V28C3.33358 28.5523 3.78129 29 4.33358 29H21.063C21.6153 29 22.063 28.5523 22.063 28V28Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 33C22.063 32.4477 21.6153 32 21.063 32H4.33358C3.78129 32 3.33358 32.4477 3.33358 33V33C3.33358 33.5523 3.78129 34 4.33358 34H21.063C21.6153 34 22.063 33.5523 22.063 33V33Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 38C22.063 37.4477 21.6153 37 21.063 37H4.33358C3.78129 37 3.33358 37.4477 3.33358 38V38C3.33358 38.5523 3.78129 39 4.33358 39H21.063C21.6153 39 22.063 38.5523 22.063 38V38Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 43C22.063 42.4477 21.6153 42 21.063 42H4.33358C3.78129 42 3.33358 42.4477 3.33358 43V43C3.33358 43.5523 3.78129 44 4.33358 44H21.063C21.6153 44 22.063 43.5523 22.063 43V43Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 48C22.063 47.4477 21.6153 47 21.063 47H4.33358C3.78129 47 3.33358 47.4477 3.33358 48V48C3.33358 48.5523 3.78129 49 4.33358 49H21.063C21.6153 49 22.063 48.5523 22.063 48V48Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 53C22.063 52.4477 21.6153 52 21.063 52H4.33358C3.78129 52 3.33358 52.4477 3.33358 53V53C3.33358 53.5523 3.78129 54 4.33358 54H21.063C21.6153 54 22.063 53.5523 22.063 53V53Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.063 58C22.063 57.4477 21.6153 57 21.063 57H4.33358C3.78129 57 3.33358 57.4477 3.33358 58V58C3.33358 58.5523 3.78129 59 4.33358 59H21.063C21.6153 59 22.063 58.5523 22.063 58V58Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0005 80C26.0005 79.4477 26.4482 79 27.0005 79H82.0005C82.5528 79 83.0005 79.4477 83.0005 80V82C83.0005 82.5523 82.5528 83 82.0005 83H27.0005C26.4482 83 26.0005 82.5523 26.0005 82V80Z",
    fill: "#BFBFBF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833496,
    y: 0.5,
    width: 85,
    height: 85,
    rx: 2.5,
    stroke: "#BFBFBF",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.549a36d1ac72ddf978945b7039387cf0.svg";
export { ForwardRef as ReactComponent };